import { useQuery } from '@apollo/client';
import { graphql } from '../../../gql/__codegen__';
import { insertCommaDelimiter } from '../../../helpers/formatter/insertCommaDelimiter';
import { PointThemePrimaryImage } from '../../parts/svgImages/PointImage';

const QUERY = graphql(`
  query shared_currentUnextPointBanner($type: PointClassInput!) {
    unextAccount {
      currentPointBalance(type: $type) {
        balance
      }
    }
  }
`);

export const CurrentUnextPointBanner: React.FC = () => {
  const { data } = useQuery(QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      type: 'POINT',
    },
  });

  return (
    <div className="flex w-fit items-end justify-center rounded-2 bg-main-5 px-4 py-2">
      <div className="text-base3">現在：</div>
      <div className="mx-1 flex items-center">
        <div>
          <PointThemePrimaryImage alt="" className="size-6" />
        </div>
        <div className="text-base1 font-bold cst-halt leading-[1.4] text-main-100">
          {data &&
            insertCommaDelimiter(data.unextAccount.currentPointBalance.balance)}
        </div>
      </div>
      <div className="text-base3">ポイント</div>
    </div>
  );
};
